import {
  getContactInfo,
  getUserProfle,
  getScoringLead,
  getRenterProfile,
  getSmartLeadEmail,
  getSmartLeadPhone,
  markLeadStatus,
  getOtherConsult,
  getCustomAnswers,
  postCustomAnswer,
  deleteCustomAnswers,
  postCustomAnswerList,
  getMessageAttachements,
  sendFeedbackEmail
} from '../../../../apiclient/resources/lead';

import { getLeadsStates } from '../../../../apiclient/resources/leads';
import { getSite, completeLocation, getMessage } from '../../../../services/utils/leads';
import * as actions from './actions';
import { InboxOperations } from '../../../menuInbox/ducks';
import { TableOperations } from '../../../leadTable/ducks';

const fetchSmartLead = contactPublisherUserId => dispatch => {
  dispatch(actions.fetchSmartLead(contactPublisherUserId));
  getUserProfle(contactPublisherUserId).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchSmartLeadSuceeded(data));

      if (
        data &&
        data.user_questionary_profiles &&
        data.user_questionary_profiles[0] !== undefined &&
        data.user_questionary_profiles[0]
      ) {
        dispatch(actions.fetchRenterProfileSuceeded(data.user_questionary_profiles[0].questions));
      } else {
        // console.error("Data or user_questionary_profiles is null or undefined");
      }
    }
  });
};

const fetchRelated = contactPublisherUserId => dispatch => {
  dispatch(actions.fetchRelated(contactPublisherUserId));
  getOtherConsult(contactPublisherUserId).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchRelatedSuceeded(data));
    }
  });
};

const fetchSmartLeadEmail = email => dispatch => {
  getSmartLeadEmail(email).then(({ error, data }) => {
    if (!error) {
      if (data) {
        dispatch(actions.fetchEmailValidationSucceeded(data));
      } else {
        dispatch(actions.fetchEmailValidationNoData(data));
      }
    }
  });
};

const fetchSendEmail = leadId => dispatch => {
  sendFeedbackEmail(leadId).then(({ error, data }) => {
    if (!error) {
      if (data) {
        dispatch(actions.sendEmailSuccess(data));
      }
    } else {
      dispatch(actions.sendEmailFailed({}));
    }
  });
};

const fetchScoreLead = contactPublisherUserId => dispatch => {
  dispatch(actions.fetchScoreLead(contactPublisherUserId));
  getScoringLead(contactPublisherUserId).then(({ error, data }) => {
    if (!error) {
      if (data) {
        dispatch(actions.fetchScoreLeadSuceeded(data));
      }
    }
  });
};

const fetchMessageAttachment = contactId => dispatch => {
  dispatch(actions.fetchMessageAttachment({}));
  getMessageAttachements(contactId).then(({ error, data }) => {
    if (!error) {
      if (data) {
        dispatch(actions.fetchMessageAttachmentSuceeded(data));
      }
    }
  });
};

const fetchRenterProfile = contactPublisherUserId => dispatch => {
  dispatch(actions.fetchRenterProfile(contactPublisherUserId));
  getRenterProfile(contactPublisherUserId).then(({ error, data }) => {
    if (!error) {
      if (data) {
        dispatch(actions.fetchRenterProfileSuceeded(data));
      }
    } else {
      dispatch(actions.fetchRenterProfileailed(data));
    }
  });
};

const fetchCustomAnswers = () => dispatch => {
  getCustomAnswers().then(({ error, data }) => {
    if (!error) {
      if (data) {
        dispatch(actions.fetchCustomAnswers(data.answers));
      } else {
        dispatch(actions.fetchCustomAnswers(undefined));
      }
    }
  });
};

const fetchAddCustomAnswer = data => dispatch => {
  postCustomAnswer(data).then(({ error }) => {
    if (!error) {
      dispatch(actions.fetchCustomAnswerStatus(true));
      fetchCustomAnswers()(dispatch);
    } else {
      dispatch(actions.fetchCustomAnswerStatus(false));
    }
  });
};

const fetchAddCustomAnswerList = data => dispatch => {
  postCustomAnswerList(data).then(({ error }) => {
    if (!error) {
      dispatch(actions.fetchCustomAnswerStatus(true));
      fetchCustomAnswers()(dispatch);
    } else {
      dispatch(actions.fetchCustomAnswerStatus(false));
    }
  });
};

const fetchUpdateEtiquetaStutus = data => dispatch => {
  dispatch(actions.fetchLeadsChangueStatus(data));
};

const fetchAddCustomAnswerStatusReset = () => dispatch => {
  dispatch(actions.fetchCustomAnswerReset());
};

const fetchDeleteCustomAnswer = customAnswerId => dispatch => {
  deleteCustomAnswers(customAnswerId).then(({ error }) => {
    if (!error) {
      dispatch(actions.fetchCustomAnswerStatus(true));
      fetchCustomAnswers()(dispatch);
    } else {
      dispatch(actions.fetchCustomAnswerStatus(false));
    }
  });
};

const fetchSmartLeadPhone = phone => dispatch => {
  getSmartLeadPhone(phone).then(({ error, data }) => {
    if (!error) {
      if (data) {
        dispatch(actions.fetchPhoneValidationSucceeded(data));
      }
    }
  });
};

const updateLeadStatus = (status, contactId, showSnackBar = true) => (dispatch, getState) => {
  const { lead } = getState();
  dispatch(actions.updateLeadStatus(status, contactId));
  markLeadStatus(status, contactId).then(({ error }) => {
    if (!error) {
      dispatch(actions.updateLeadStatusSuceeded(status));
      dispatch(TableOperations.updateLeadStatusSucceeded({ leadStatus: status, contactIds: [contactId] }));
      InboxOperations.fetchUnread(lead.inbox.status, false)(dispatch);
      if (showSnackBar) {
        dispatch(
          actions.showSnackBar({
            key: `${contactId}${status}`,
            message: getMessage(1, status)
          })
        );
      }
    } else {
      dispatch(actions.updateLeadStatusFailed(error));
      if (showSnackBar) {
        dispatch(
          actions.showSnackBar({
            key: `${contactId}${status}`,
            message: getMessage(1, status),
            error: true
          })
        );
      }
    }
  });
};

const updateLeadStatusWithCallback = (status, contactId, reason, callback) => (dispatch, getState) => {
  const { lead } = getState();
  dispatch(actions.updateLeadStatus(status, contactId));
  markLeadStatus(status, contactId, reason).then(({ error }) => {
    if (!error) {
      dispatch(actions.updateLeadStatusSuceeded(status));
      InboxOperations.fetchUnread(lead.inbox.status, false)(dispatch);
      callback();
    } else {
      dispatch(actions.updateLeadStatusFailed(error));
    }
  });
};

const fetchLeadsEtiquetas = () => dispatch => {
  dispatch(actions.fetchLeadsStatus());
  getLeadsStates().then(({ error, data }) => {
    if (!error) {
      if (data) {
        dispatch(actions.fetchLeadsStatusSucess(data));
      }
    }
  });
};

const fetchLeadInfoData = contactId => (dispatch, getState) => {
  dispatch(actions.fetchLeadInfo(contactId));
  fetchLeadsEtiquetas()(dispatch);
  markLeadStatus('READ', contactId, null).then(({ error }) => {
    if (!error) {
      dispatch(actions.fetchFeedbackReset({}));
      dispatch(actions.fetchSmartLeadReset({}));
      dispatch(actions.fetchRenterProfileReset({}));
      getContactInfo(contactId).then(({ error, data }) => {
        if (!error) {
          if (data.posting) {
            data.posting.completeLocation = completeLocation(data.posting);
            data.posting.currency = data.posting.price ? data.posting.price.currency : '';
            data.posting.price = data.posting.price ? data.posting.price.amount : '';
          }

          if (data.lead_user) {
            dispatch(actions.fetchLeadInfoSuceeded(data));
            fetchSmartLead(contactId)(dispatch);
            fetchRelated(contactId)(dispatch);
            fetchMessageAttachment(data.id)(dispatch);
            /*   if (
              data &&
              data.posting &&
              data.posting.price_operation_types[0] &&
              data.posting.price_operation_types[0].operation_type.operation_type_id &&
              data.posting.price_operation_types[0].operation_type.operation_type_id === '2' // alquiler
            ) {
              fetchRenterProfile(contactId)(dispatch);
            } else if (!data.posting || data.posting === undefined) {
              fetchRenterProfile(contactId)(dispatch);
            } */
          }
          if (data.lead_user.email) {
            fetchSmartLeadEmail(data.lead_user.email)(dispatch);
          }

          if (data.phone_list && data.phone_list.length > 0) {
            data.phone_list.forEach(phoneNumber => {
              if (phoneNumber) {
                fetchSmartLeadPhone(phoneNumber.phone)(dispatch);
              }
            });
          }
          fetchCustomAnswers()(dispatch);

          /*
          Se comenta la pegada de momento hasta que se habilite la feature
          if (data && data.posting && getSite() === 'ZPAR') {
            fetchScoreLead(contactId)(dispatch);
          } else {
            dispatch(actions.fetchScoreLeadNoPosting());
          } */
        } else {
          dispatch(actions.fetchLeadInfoFailed(error));
        }
      });
    } else {
      dispatch(actions.fetchLeadInfoFailed(error));
    }
  });
};

const fetchselectedPhone = data => dispatch => {
  dispatch(actions.setSelectedPhone(data));
};

export {
  fetchLeadInfoData,
  fetchSmartLeadPhone,
  fetchSmartLeadEmail,
  updateLeadStatus,
  fetchSmartLead,
  fetchScoreLead,
  fetchRenterProfile,
  fetchRelated,
  updateLeadStatusWithCallback,
  fetchCustomAnswers,
  fetchAddCustomAnswer,
  fetchDeleteCustomAnswer,
  fetchAddCustomAnswerStatusReset,
  fetchAddCustomAnswerList,
  fetchMessageAttachment,
  fetchselectedPhone,
  fetchLeadsEtiquetas,
  fetchSendEmail,
  fetchUpdateEtiquetaStutus
};
